var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-timeline',_vm._l((_vm.timeline),function(item,index){return _c('app-timeline-item',{key:index,attrs:{"subtitle":item.subtitle,"time":item.time,"title":item.title,"variant":item.variant}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }